export default __webpack_public_path__ + "static/media/mypicture.4317d0b5.jpg";